export const generalKey = 'product_sp_400w_solar_panel';
export const whiteLocaleList = ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es']; //白名单
export const productPageUrl = 'a-new-era-of-cool';
export const tabsValues = ['Product', 'Bundles'];
export const productPageTheme = 'white'; //主题色

export const usersSaysLocales = ['us', 'ca', 'de', 'fr', 'it', 'uk'];
export const noUsersSaysVideoLocales = ['de', 'fr', 'it', 'uk'];
export const needTermsCheckLocales = ['us', 'ca'];
export const checkLocaleLabel = ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es'];
